import NotFound from "@/components/not-found";
import { createBrowserRouter, redirect } from "react-router-dom";
import { AuthenticationProvider } from "./common/providers/authentication";
import AuthenticationRoute, {
	LoginRoute,
} from "./features/authentication/route";
import HomeRoute from "./features/home/route";

const router = createBrowserRouter([
	HomeRoute,
	AuthenticationRoute,
	{
		path: "/logout",
		async action() {
			await AuthenticationProvider.signout();
			return redirect(LoginRoute);
		},
	},
	{
		path: "*",
		element: <NotFound />,
	},
]);

export default router;
